import React from 'react'

export default function Terms() {
  return (
    <div className='shadow-xl border border-borderFade rounded-xl px-4 py-4 h-full flex flex-col justify-center select-none'>
        <h5 className='text-sm font-bold mb-4'>
        لطفا در پرداخت اقساط خود به موارد زیر دقت نمایید:
        </h5>
        <p className='text-custom13 font-light text-justify leading-5'>
        حتما قبل از پرداخت نام صاحب وام را چک نمایید. در صورت پرداخت اقساطی که برای شخص دیگری باشد به هیچ عنوان امکان بازگشت وجه وجود نخواهد داشت.
        </p>
        <p className='text-custom13 font-light text-justify leading-5 my-3'>
        برای جلوگیری از مشمول جریمه شدن، حتما اقساط خود را حداکثر تا زمان سررسید آن پرداخت نمایید. در غیر این صورت به صورت روزانه شامل جریمه خواهید شد.
        </p>
    </div>
  )
}
